import React, { useState, useEffect } from 'react';
import './HealthCheck.css';

const API_BASE = process.env.REACT_APP_API_URL || '';

function HealthCheck() {
  const [status, setStatus] = useState({
    frontend: 'up',
    backend: 'checking...',
    database: 'checking...',
    error: null
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkHealth = async () => {
      try {
        const response = await fetch(`${API_BASE}/api/health`);
        if (response.ok) {
          const data = await response.json();
          setStatus({
            frontend: 'up',
            backend: data.backend || 'up',
            database: data.database || 'up',
            error: null
          });
        } else {
          // If backend returns 500, it might still return JSON with database down
          try {
            const data = await response.json();
            setStatus({
              frontend: 'up',
              backend: data.backend || 'up',
              database: data.database || 'down',
              error: data.error || 'Database error'
            });
          } catch (e) {
            setStatus({
              frontend: 'up',
              backend: 'down',
              database: 'unknown',
              error: 'Backend is unreachable'
            });
          }
        }
      } catch (error) {
        setStatus({
          frontend: 'up',
          backend: 'down',
          database: 'unknown',
          error: 'Connection refused or backend offline'
        });
      } finally {
        setLoading(false);
      }
    };

    checkHealth();
  }, []);

  const getStatusClass = (statusState) => {
    if (statusState === 'up') return 'status-up';
    if (statusState === 'down') return 'status-down';
    return 'status-pending';
  };

  const getStatusIcon = (statusState) => {
    if (statusState === 'up') return '✅';
    if (statusState === 'down') return '❌';
    return '⏳';
  };

  return (
    <div className="health-container">
      <div className="health-header">
        <h1>System Health Status</h1>
        <p>Real-time monitoring of SponsorBoat infrastructure components</p>
      </div>

      <div className="health-content">
        {loading ? (
          <div className="health-loading">Running diagnostics...</div>
        ) : (
          <div className="health-grid">
            <div className={`health-card ${getStatusClass(status.frontend)}`}>
              <div className="health-icon">🌐</div>
              <h3>Frontend</h3>
              <p>React Application</p>
              <div className="status-badge">
                {getStatusIcon(status.frontend)} {status.frontend.toUpperCase()}
              </div>
            </div>

            <div className={`health-card ${getStatusClass(status.backend)}`}>
              <div className="health-icon">⚙️</div>
              <h3>Backend</h3>
              <p>Node.js / Express API</p>
              <div className="status-badge">
                {getStatusIcon(status.backend)} {status.backend.toUpperCase()}
              </div>
            </div>

            <div className={`health-card ${getStatusClass(status.database)}`}>
              <div className="health-icon">s💾</div>
              <h3>Database</h3>
              <p>SQLite Storage</p>
              <div className="status-badge">
                {getStatusIcon(status.database)} {status.database.toUpperCase()}
              </div>
            </div>
          </div>
        )}

        {status.error && (
          <div className="health-error">
            <strong>Error Details:</strong> {status.error}
          </div>
        )}
        
        {!loading && (
          <button 
            className="refresh-button" 
            onClick={() => window.location.reload()}
          >
            Refresh Status
          </button>
        )}
      </div>
    </div>
  );
}

export default HealthCheck;
